import type React from 'react';

import { Text } from '@change/ds-core-ui/Text';
import { CheckmarkVerifiedIcon } from '@change/ds-icons/CheckmarkVerifiedIcon';

import { Translate } from '@change-corgi/core-react/i18n';

import { useProfileCard } from '../../hooks/useProfileCard';

export const NameAndTitle: React.FC<EmptyProps> = () => {
	const {
		data: { displayName, title, districtStateText, verified },
	} = useProfileCard();

	return (
		<div className="flex flex-col items-center lg:items-start">
			<Text as="p" variant="body" size="large" className="text-typography-weak hidden lg:block">
				<Translate value="corgi.decision_maker_profile.profile_section.label" />
			</Text>
			<div className="my-2 flex items-start">
				<Text as="h1" variant="heading" className="my-0 mb-2 text-4xl xl:text-5xl" data-qa="dm-name">
					{displayName}
				</Text>
				{verified && (
					<CheckmarkVerifiedIcon size="small" data-testid="verified-badge" className="text-icon-information ml-2" />
				)}
			</div>
			<Text as="p" variant="body" className="text-center lg:text-left" data-qa="dm-title">
				{title}
			</Text>
			{districtStateText && (
				<Text as="p" data-testid="dm-profile-location" variant="body">
					{districtStateText}
				</Text>
			)}
		</div>
	);
};
